<template>
    <main class="container">
        <div class="card">
            <div class="card-body text-center">
                <i class="fas fa-exclamation-triangle mb-3" style="font-size: 10em; color:#afafaf"></i>
                <h3 style="color:#292929">
                    Φαίνετε να μην έχετε πρόσβαση
                </h3>
                <p style="font-size: 1.2em">
                    Η προσφορά που ψάγνετε έχει λήξει, ή δεν έχετε πλέον πρόσβαση σε αυτήν. Επικοινωνήστε μαζί μας για
                    να σας δώσουμε πρόσβαση.
                </p>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: "Error"
    }
</script>

<style scoped>

</style>